import { useFormik } from "formik";
import React, { useContext, useState } from "react";
import { useEffect } from "react";
import { FaPlus, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";
import { httpReauest } from "../../../utils/httpRequest";
import * as Yup from "yup";
import { BASE_URL } from "../../../config";
import Loading from "../Loading";
import { AuthContext } from "../../../context/AuthContext";
import Select from "react-select";

const CreateEventForm = () => {
  const [img, setImg] = useState();
  const [images, setImages] = useState([]);
  const [previews, setPreview] = useState([]);
  const [previewImg, setPreviewImg] = useState();
  const [loading, setloading] = useState();
  const [vehicles, setvehicles] = useState([]);
  const [urls, seturls] = useState([]);
  const [repeatedname, setrepeatedname] = useState();
  const [file, setfile] = useState();
  const [disabled, setdisabled] = useState(false);
  const [errorUrl, seterrorUrl] = useState(false);
  const [details, setdetails] = useState([]);

  const VALUE_SIGN_VALIDATION = () => {
    return Yup.object({
      name: Yup.string().required("الزامی است"),
      category: Yup.string().required("الزامی است"),
      desc: Yup.string().required("الزامی است"),
    });
  };

  const { user, setUser } = useContext(AuthContext);

  console.log(file)

  const formik = useFormik({
    initialValues: {
      category: "",
      name: "",
      desc: "",
      date: "",
      price: "",
      location: "",
    },
    validationSchema: VALUE_SIGN_VALIDATION,
    onSubmit: async (values) => {
      setloading(true);
      const formdata = new FormData();
      formdata.append("name", values.name);
      formdata.append("category", values.category);
      formdata.append("desc", values.desc);
      formdata.append("date", values.date);
      formdata.append("price", values.price);
      formdata.append("location", values.location);
      if (img) {
        formdata.append("img", img, img?.name);
      }
      if (file) {
        formdata.append("voice", file, file?.name);
      }
      if (images) {
        for (let index = 0; index < images.length; index++) {
          formdata.append("images", images[index], images[index]?.name);
        }
      }

      await fetch(BASE_URL + "/event", {
        method: "POST",
        body: formdata,
        headers: { "x-access-token": user.token },
      }).then((dat) => {
        if (dat?.status == 201) {
          toast.success("رویداد ساخته شد");
          setloading(false);
          formik.resetForm();
          setImg(null);
          setImages([]);
          setPreviewImg(null);
          setPreview([]);
        } else {
          const message = dat.json();
          setloading(false);
          toast.error(message?.message);
        }
      });
    },
  });

  useEffect(() => {
    getData();
  }, []);

  function handleImg(e) {
    const fils = e.target.files[0];
    if (fils.size > 2031517) {
      toast.error("حجم فایل باید کمتر از دو مگابایت باشد");
    } else {
      setImg(fils);
      setPreviwImage(fils);
    }
  }

  function handleImages(e) {
    const fils = e.target.files;
    if (fils) {
      for (let index = 0; index < fils?.length; index++) {
        if (fils[index].size > 2031517) {
          toast.error("حجم فایل باید کمتر از دو مگابایت باشد");
        } else {
          if (images.length > 5) {
            toast.error("تعداد عکس ها بیشتر از 6 عدد نمی شود");
          } else {
            setImages((current) => [...current, fils[index]]);
            setPreviwImages(fils[index]);
          }
        }
      }
    }
  }

  async function setPreviwImages(i) {
    const reader = new FileReader();
    reader.onloadend = function () {
      setPreview((current) => [...current, reader.result]);
    };
    reader.readAsDataURL(i);
  }

  async function setPreviwImage(imgInput) {
    const reader = new FileReader();
    reader.onloadend = function () {
      setPreviewImg(reader.result);
    };
    reader.readAsDataURL(imgInput);
  }

  async function getData() {
    await httpReauest("GET", "/event/category", {}, {}).then(({ data }) => {
      seturls(data.data);
    });
  }

  async function deleteImg(index) {
    setPreview((students) => students.filter((s, i) => i != index));
    setImages((students) => students.filter((s, i) => i != index));
  }

  function handleChange(params) {
    const value = params.target.value;
    const formattedValue = (
      Number(value.replace(/\D/g, "")) || ""
    ).toLocaleString();
    formik.setFieldValue("price", formattedValue);
  }

  return (
    <div>
      <h2 className="text-[20px] mb-8 font-bold p-3">فرم ایجاد رویداد</h2>
      <form
        onSubmit={formik.handleSubmit}
        className="grid grid-cols-1 lg:grid-cols-3 2xl:grid-cols-4 gap-6"
      >
        <span className="relative">
          <input
            id="name"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          />

          {formik.errors.name && formik.touched.name && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.name}
            </small>
          )}
          <p className="on-border font-bold">نام رویداد*</p>
        </span>
        <span className="relative">
          <input
            id="price"
            name="price"
            value={formik.values.price}
            onChange={handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          />

          {formik.errors.price && formik.touched.price && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.price}
            </small>
          )}
          <p className="on-border font-bold">قیمت ثبت نام (تومان)</p>
        </span>
        <span className="relative">
          <input
            id="location"
            name="location"
            value={formik.values.location}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          />

          {formik.errors.location && formik.touched.location && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.location}
            </small>
          )}
          <p className="on-border font-bold"> آدرس</p>
        </span>
        <span className="relative">
          <select
            id="category"
            name="category"
            value={formik.values.category}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          >
            <option></option>
            {urls?.map((item) => (
              <option value={item._id}>{item.name}</option>
            ))}
          </select>
          {formik.errors.category && formik.touched.category && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.category}
            </small>
          )}
          <p className="on-border font-bold">دسته بندی*</p>
        </span>

        <label
          htmlFor="img"
          className="relative w-full border-dashed border rounded-[10px] p-3 h-[200px] cursor-pointer border-[#444]"
        >
          {previewImg ? (
            <img
              src={previewImg}
              className="w-full h-full object-contain"
              alt=""
            />
          ) : (
            <FaPlus className="center" size={30} />
          )}

          <p className="on-border font-bold">تصویر اصلی</p>
        </label>
        <span className="relative">
          <input
            id="date"
            name="date"
            type="date"
            value={formik.values.date}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          />

          {formik.errors.date && formik.touched.date && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.date}
            </small>
          )}
          <p className="on-border font-bold">تاریخ رویداد*</p>
        </span>
        <span>
          <p className="mb-3 font-bold">ویس رویداد</p>
          <input
            onChange={(e) => {
              setfile(e.target.files[0]);
            }}
            id="file"
            type="file"
          />
        </span>
        <input
          onChange={(e) => {
            handleImg(e);
          }}
          type="file"
          className="hidden"
          id="img"
          accept="image/png, image/jpg, image/jpeg"
        />

        <span className="relative col-span-full lg:col-span-2">
          <textarea
            id="desc"
            name="desc"
            value={formik.values.desc}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={disabled}
            className="w-full form-brand min-h-[88px]"
          />
          <p className="on-border font-bold">توضیحات</p>
        </span>
        <div className="relative col-span-full w-full border-dashed border rounded-[10px] p-3 min-h-[340px]  border-[#444]">
          {previews?.length > 0 ? (
            <div
              className="p-3"
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "15px",
              }}
            >
              {previews &&
                previews.map((src, i) => {
                  return (
                    <span className="relative">
                      <img
                        src={src}
                        style={{
                          width: "150px",
                          height: "150px",
                          objectFit: "contain",
                        }}
                        alt=""
                      />
                      <FaTrash
                        color="red"
                        className="top-0 right-0 absolute"
                        onClick={() => deleteImg(i)}
                      />
                    </span>
                  );
                })}
              <label htmlFor="images" className="cursor-pointer">
                <FaPlus size={50} />
              </label>
            </div>
          ) : (
            <label htmlFor="images" className="cursor-pointer">
              <FaPlus className="center" size={50} />
            </label>
          )}

          <p className="on-border font-bold">تصاویر</p>
        </div>
        <input
          onChange={(e) => {
            handleImages(e);
          }}
          type="file"
          className="hidden"
          id="images"
          accept="image/png, image/jpg, image/jpeg"
        />
        {loading ? (
          <Loading />
        ) : (
          <button type="submit" className="btn-brand">
            ارسال
          </button>
        )}
      </form>
    </div>
  );
};

export default CreateEventForm;
